import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { updateTextField, translateFieldShiftFlag } from 'components/Briefing/helpers';
import toast from 'react-hot-toast';

const TextField = ({ field, maxLength = 250, minLength = -1, inputFilter = null, onBackendSync = null, trackShift=false }) => {
    if (!field) {
        return (
            <>
                <textarea
                    className={`input`}
                    value={`Phantom box`}
                    rows="1"
                    disabled={true}
                />
                <span
                    className='input-updated-at-label'
                >
                    Updated: Never
                </span>
            </>
        );
    }

    const [value, setValue] = useState(field.value);
    const [id, setID] = useState(field.parent);
    const textareaRef = useRef(null);
    const [fieldShift, setFieldShift] = useState(translateFieldShiftFlag(field.shift_flag));
    // const userShift = useSelector((state) => state.shift);
    
    if (trackShift) {
        var userShift = useSelector((state) => state.shift);
    }
    else {
        var [userShift, setUserShift] = useState(null);
    }

    const briefing = useSelector((state) => state.briefing.line);


    let disabled = true
    if (briefing === "Briefings") {
        disabled = false
    }

    useEffect(() => {
        if (textareaRef.current) {
            // Adjust height
            textareaRef.current.style.height = "auto";
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [value]);

    const handleInputChange = (event) => {
        setValue(event.target.value);
    };

    const handleBlur = () => {
        if (value !== field.value) {
            const tempMaxLength = maxLength + 1
            if (value.length < tempMaxLength && value.length > minLength) {
                if (!inputFilter || inputFilter.filter(value)) {
                    updateTextField(id, value, userShift);
                    setFieldShift(userShift)
                    if (onBackendSync) {
                        onBackendSync()
                    }
                }
                else {
                    setFieldShift('error-shift')
                    toast.error(inputFilter.message)
                }
            }
            else {
                setFieldShift('error-shift')
                if (value.length > tempMaxLength) {
                    toast.error('Text too long')
                }
                if (value.length < minLength) {
                    toast.error('Text too short')
                }
            }
        }
    };

    return (
        <>
            <textarea
                maxLength={maxLength}
                minLength={minLength}
                ref={textareaRef}
                className={`input autoExpand ${fieldShift}`}
                value={value}
                onChange={handleInputChange}
                onBlur={handleBlur}
                placeholder="Hungry box"
                rows="1" // Start with one row
                disabled={disabled}
            />
            <span
                className='input-updated-at-label'
            >
                Updated: {field.updated_at} by {field.updated_by}
            </span>
        </>
    );
};

export { TextField };

